<template>
    <div class="color-currents-banner">
        <div class="color-currents-banner__container">
            <span class="color-currents-banner__bold">Discover Color Currents:&nbsp;</span><span class="color-currents-banner__regular">a thoughtfully curated, painted palette of new, captivating hues.</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorCurrentsBanner'
}
</script>

<style lang="scss">
.color-currents-banner {
    @apply bg-green text-clay;
    @apply w-full;
    
    &__container {
        @apply mx-auto px-4;
        @apply flex items-center justify-center;
        @apply pt-4 pb-4; // Match selection header padding (1rem = 16px each)
        @apply text-center;
        flex-wrap: wrap; // Allow text to wrap on mobile
        white-space: pre-wrap; // Preserve whitespace (including space after colon) while allowing wrapping
        
        font-family: 'Montserrat', sans-serif;
        @apply text-lg; // Match selection header text size (18px)
        @apply uppercase;
        @apply leading-normal; // Use normal line-height like selection header
        letter-spacing: 0%;
    }
    
    &__bold {
        font-weight: 600;
        font-style: normal;
    }
    
    &__regular {
        font-weight: 400;
        font-style: normal;
    }
}
</style>

